export class BatchValidateResourceConfigurationResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<BatchResourceValidationResult>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchValidateResourceConfigurationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
